import React from "react";

/** One heading rhythm for chat cards, saved documents and expanded sources. */
export default function StudioSectionHeading({ title, icon, description, action, primary = false }: {
  title: React.ReactNode; icon?: React.ReactNode; description?: React.ReactNode; action?: React.ReactNode; primary?: boolean;
}) {
  const Heading = primary ? "h2" : "h3";
  return <div className={`studio-section-heading${action ? " studio-section-heading-with-action" : ""}${primary ? " studio-section-heading-primary" : ""}`}>
    {icon && <span className="studio-section-heading-icon" aria-hidden="true">{icon}</span>}
    <div className="studio-section-heading-copy">
      <Heading>{title}</Heading>
      {description && <div className="studio-section-description">{description}</div>}
    </div>
    {action && <div className="studio-section-heading-action">{action}</div>}
  </div>;
}
